// extracted by mini-css-extract-plugin
module.exports = {"myItemTitle":"SubscriptionActivity_myItemTitle__3lKE_","abonnee-resend-activation-button":"SubscriptionActivity_abonnee-resend-activation-button__nl6ZX"};